<template>
  <button :class="disabled ? 'disabled' : ''" class="btn">
    <slot/>
  </button>
</template>
<script>
export default {
  name: 'Tbutton',
  props: {
    disabled: Boolean,
    blank: Boolean
  }
}
</script>
<style lang="scss" scoped>
.btn {
  min-width: 120px;
  padding: 0 10px;
  height: 30px;
  box-sizing: border-box;
  background: #7996f5;
  border-radius: 19px;
  outline: none;
  color: #fff;
  cursor: pointer;
  &.btn_s{
    height: 24px;
    min-width: 100px;
  }
}
.btn:hover {
  background: #8ca6fd;
}
.btn.disabled {
  background: #e5e5e5;
  cursor: not-allowed;
  color: #bcbcbc;
}
</style>

